import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "border h-72 w-full overflow-auto relative" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Copy to Clipboard ")
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BaseButton, {
      style: {"position":"sticky","top":"0"},
      class: "mt-4 mr-4 float-right",
      disabled: _ctx.loading,
      onClick: _ctx.copyToClipboard
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["disabled", "onClick"]),
    (_ctx.copyEnable)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref: "container",
          class: "ml-8 mb-8",
          innerHTML: _ctx.formatContext
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}